import React, { useState, useEffect } from 'react';
import { faPencilAlt, faFileAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Stepper from '../../components/Stepper/Stepper';
import TextField from '../../components/TextField/TextField';
import ContainerFichaFormularioDeFiscalizacao from './components/ContainerFichaFormularioDeFiscalizacao';
import Cabecalho from './components/Cabecalho';
import Questao from './components/Questao';
import Loading from '../../components/Loading/Loading';

//Helpers
import { showMessage } from '../../helpers/message';
import { objCampo, validarCampos } from '../../helpers/ValidadorDeCampos';


//Api
import formularioVistoria_api from '../../api/formularioVistoria_api';
import modalidadeColeta_api from '../../api/modalidadeColeta_api';

//Estado inicial do formulario
function initialStateFormulario() {
    return {
        identificacao: "",
        entidadeFiscalizada: null,
        modalidades: [],
        ativo: true,
        cabecalhos: [],
        questoes: [],
    }
}

export default function NovoFormularioDeFiscalizacao({ btnVoltar, formularioEdit = null }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da visualização do formulario de cabeçalho
    const [openFormCabecalho, setOpenFormCabecalho] = useState(false);

    //Estado que guarda os dados do formulario
    const [formulario, setFormulario] = useState(formularioEdit ? formularioEdit : initialStateFormulario);

    //Estado de controle da visualização do formulario de cabeçalho
    const [openFormQuestao, setOpenFormQuestao] = useState(false);

    //Estado que faz o controle do passo ativo do stepper
    const [activeStep, setActiveStep] = useState(1);

    //Estado para controla o tipo de entidade fiscalizada
    const [optionsEntidadeFiscalizada] = useState([
        { label: "Gerador", value: "Gerador" },
        { label: "Transportador", value: "Transportador" }
    ]);

    //Estado de controle dos campos de erros
    const [errors, setErrors] = useState({});

    //Campos que podem estar errado da identificação
    const camposIdentificacao = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "entidadeFiscalizada", required: true })
    ]

    //Função que valida os campos de identificacao
    const validarIdentificacao = () => {
        const _errors = validarCampos(formulario, camposIdentificacao);
        setErrors(_errors[0]);
        return _errors[1];
    }

    const [tiposColetas, setTiposColetas] = useState([])
    useEffect(() => {
        setLoading(true)
        modalidadeColeta_api.GetList("Ativo")
            .then(res => {
                res.data.map(v => {
                    v.label = v.descricao;
                    v.value = v.id;
                })

                setTiposColetas(res.data)
            })
            .catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
    }, []);

    //Passos para o cadastro do formulario
    const steps = () => {
        return ([
            { text: "Identificação do formulario", icon: faFileAlt, validateStep: validarIdentificacao },
            { text: "Cabeçalhos", icon: faPencilAlt, btnAdicionar: () => setOpenFormCabecalho(!openFormCabecalho) },
            {
                text: "Questões", icon: faPencilAlt, btnAdicionar: () => setOpenFormQuestao(!openFormQuestao), validateStep: () => {
                    if (formulario.questoes.length == 0) {
                        showMessage("Aviso", "Informe ao menos uma questão para continuar", "warning", null)
                        return [0];
                    }
                }
            },
            { text: "Finalizar", icon: faCheck }
        ]);
    }

    //OnChange para identificacao
    const onChangeIdentificacao = (e) => {
        const { name, value } = e.target;

        setFormulario({
            ...formulario,
            [name]: value
        })
    }

    //OnChange do campo ativo
    const onChangeAtivo = (e) => {
        const { name, checked } = e.target;

        setFormulario({
            ...formulario,
            [name]: checked
        })
    }

    //Enviando dados para salvar na api
    const onSubmit = () => {
        const _formulario = { ...formulario };
        _formulario.cabecalhos = _formulario.cabecalhos.map(value => {
            if (value.tipoValor === "Lista") {
                value.opcoes = value.opcoes.map(option => {
                    const _opcao = { valor: option.value };
                    if (option.id) {
                        _opcao.id = option.id;
                    }
                    return _opcao
                })
            }
            return value;
        });
        _formulario.questoes = _formulario.questoes.map(value => {
            if (value.tipoValor === "Lista") {
                value.opcoes = value.opcoes.map(option => {
                    const _opcao = { valor: option.value, geraInconformidade: value?.opcoesQueGeramInconformidade?.filter(opi => opi.value === option.value).length > 0 };
                    if (option.id) {
                        _opcao.id = option.id;
                    }
                    return _opcao
                })
            }
            return value;
        });


        setLoading(true);
        if (formulario.id) {
            formularioVistoria_api.Put(_formulario).then(response => {
                showMessage("Sucesso!", "Formulario atualizado com sucesso!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso!", e.message, "error", null);
            }).finally(f => setLoading(false))
        } else {
            formularioVistoria_api.Post(_formulario).then(response => {
                showMessage("Sucesso!", "Formulario criado com sucesso!", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso!", e.message, "error", null);
            }).finally(f => setLoading(false))
        }

    }

    const onChangeModalidades = (e, select) => {
        setFormulario({
            ...formulario,
            [select.name]: e
        });
    }

    //onChange para a questão vinculada
    const onChangeEntidadeFiscalizada = (e, select) => {
        const { name } = select;
        let _modalidades = e != null && e.value == "Transportador" ? [] : [...formulario.modalidades];

        const _formulario = {
            ...formulario,
            [select.name]: e != null ? e.value : null,
            modalidades: _modalidades
        };

        const campo = camposIdentificacao.filter(c => c.name === name);
        const _errors = validarCampos(_formulario, campo);

        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setFormulario(_formulario)
    }

    //Função que retorna o valor do passo ativo na tela
    const getStepContainer = (step) => {
        switch (step) {
            case 1:
                return (
                    <div>
                        <Row>
                            <Col lg="7">
                                <TextField
                                    invalid={!!errors.identificacao}
                                    label={"* Identificação"}
                                    name="identificacao"
                                    onChange={onChangeIdentificacao}
                                    value={formulario.identificacao}
                                />
                            </Col>
                            <Col lg="3">
                                <TextField
                                    label={"Entidade Fiscalizada"}
                                    searchable
                                    type={"select"}
                                    options={optionsEntidadeFiscalizada}
                                    name="entidadeFiscalizada"
                                    placeholder='Selecione a entidade fiscalizada'
                                    value={optionsEntidadeFiscalizada?.filter(x => x.value == formulario.entidadeFiscalizada)[0]}
                                    onChange={onChangeEntidadeFiscalizada}
                                    invalid={!!errors.entidadeFiscalizada}
                                />
                            </Col>
                            <Col lg="2">
                                <TextField
                                    type={"checkbox"}
                                    label={"Ativo?"}
                                    name="ativo"
                                    onChange={onChangeAtivo}
                                    value={formulario.ativo}
                                />
                            </Col>
                            {(formulario.entidadeFiscalizada == null || formulario.entidadeFiscalizada != "Transportador") &&
                                <Col lg="12">
                                    <TextField
                                        invalid={!!errors.modalidades}
                                        label={"Modalidades do Formulário"}
                                        type={"select"}
                                        multiple
                                        options={tiposColetas}
                                        name="modalidades"
                                        onChange={onChangeModalidades}
                                        value={formulario.modalidades}
                                    />
                                </Col>
                            }
                        </Row>
                    </div>
                )
            case 2:
                return (
                    <Cabecalho
                        formulario={formulario}
                        setFormulario={setFormulario}
                        openFormCabecalho={openFormCabecalho}
                        setOpenFormCabecalho={setOpenFormCabecalho}
                    />
                )
            case 3:
                return (
                    <Questao
                        formulario={formulario}
                        setFormulario={setFormulario}
                        openFormQuestao={openFormQuestao}
                        setOpenFormQuestao={setOpenFormQuestao}
                    />
                )
            case 4:
                return (
                    <div>
                        <ContainerFichaFormularioDeFiscalizacao formulario={formulario} />
                    </div>
                )
        }
    }
    return (
        <MainCard btnVoltar={btnVoltar} >
            {loading && <Loading />}
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Stepper steps={steps()} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                {getStepContainer(activeStep)}
            </Stepper>
        </MainCard>
    );
}
